import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_LEGAL_PERSON_UPLOAD,
  STORE_LEGAL_PERSON_FINISH_UPLOAD,
  STORE_STATUS_INITIALIZED,
} from 'constants/store'
import { ErrorStore } from '@types'
import { createGenericSlice, GenericState } from 'stores/generics/create-slice'
import { createReducers, ExtraReducers } from 'stores/generics/create-reducers'
import { Payload } from 'stores'

export type FinishUploadState = {}

type State = GenericState<FinishUploadState>

export const initialState: State = {
  data: {},
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const patchFinishUpload = createAsyncThunk<
  FinishUploadState,
  Promise<unknown>,
  Payload
>(STORE_LEGAL_PERSON_FINISH_UPLOAD, async (promise, { rejectWithValue }) => {
  try {
    return await promise
  } catch (e: unknown) {
    const { code, message } = e as ErrorStore
    return rejectWithValue({ code, message })
  }
})

const extraReducers: ExtraReducers = createReducers<
  FinishUploadState,
  unknown,
  Payload
>(patchFinishUpload, initialState.data)

const slice = createGenericSlice({
  name: STORE_LEGAL_PERSON_UPLOAD,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = slice

const { clear } = actions

export { clear }

export default reducer
